import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'LoadingSpinner',
  props: {
    text: null,
    size: null,
    variant: null
  },
  setup(__props: any) {

const props = __props as {
  text?: string;
  size?: "small" | "medium" | "large";
  variant?: "inline" | "overlay";
};



const containerClass = computed(
  () => `loading-spinner-container--${props.variant || "inline"} loading-spinner-container--${props.size || "medium"}`
);

return { __sfc: true,props, containerClass }
}

})